<template>
  <div class="p-page-wrapper">
    <template v-if="!currentProjectId">
      <v-row>
        <v-col>
          <p-no-data
            :text="$t('noProjects')"
            :hide-btn="true"
            img="post.png"
            class="p-no-data-mt"
          ></p-no-data>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <p-routed-tabs
        :tabs="accessibleTabs"
        class="pt-1"
      ></p-routed-tabs>
      <router-view/>
    </template>
  </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

import PRoutedTabs from '@/components/PRoutedTabs'
import PNoData from '@/components/PNoData'

import snackbarMixin from '@/mixins/snackbar.mixin'
import pageMixin from '@/mixins/page.mixin'
import accessMixin from '@/mixins/access.mixin'

export default {
  components: {
    PRoutedTabs,
    PNoData
  },


  mixins: [
    snackbarMixin,
    pageMixin,
    accessMixin
  ],


  data () {
    return {
      tabs: [
        { title: this.$t('marketing.tabs.posts'), route: 'marketingPost' },
        { title: this.$t('marketing.tabs.socialAccounts'), route: 'marketingSocialAccounts' }
      ]
    }
  },


  computed: {
    ...mapGetters('project', ['currentProjectId'])
  },


  methods: {
    ...mapActions('socialMedia', ['loadSocialMedias']),
    ...mapActions('socialMediaChannel', ['loadSocialMediaChannels'])
  },


  async created () {
    this.setPageTitle(this.$t('nav.marketing'))
    if (!this.currentProjectId) return false
    try {
      await this.loadSocialMedias()
      await this.loadSocialMediaChannels()
      this.redirectToChildRouteWithAccess()
    } catch (error) {
      this.showSnackbarError()
      this.$log.error(error)
    } finally {
      this.stopPageLoading()
    }
  }
}
</script>
